import { Box, VStack, Flex, Image, Text, Badge, HStack } from "@chakra-ui/react";

export interface RewardBoxProps {
    rewards: {
      image: string;
      name: string;
      symbol: string;
      description: string;
    }[];
}

export const RewardBox = ({ rewards }: RewardBoxProps) => {
    return (
        <VStack spacing={6} align="stretch">
        <Text fontSize="lg" fontWeight="semibold" color="white">
          Rewards
        </Text>
        <VStack spacing={4} align="stretch">
          <Box
            key={"kyros"}
            p={4}
            borderRadius="8px"
            backgroundColor="whiteAlpha.100"
            transition="all 0.2s"
            _hover={{
              backgroundColor: "whiteAlpha.200",
              transform: "translateY(-2px)",
            }}
          >
            {rewards.map((reward) => (
            <Flex alignItems="center" gap={4}>
              <Image
                src={reward.image}
                alt={reward.name}
                boxSize="40px"
                borderRadius="full"
              />
              <VStack align="flex-start" spacing={1} flex="1">
                <HStack spacing={2} align="center">
                  <Text fontSize="lg" fontWeight="semibold" color="white">
                    {reward.name}
                  </Text>
                  <Badge
                    colorScheme={"green"}
                    borderRadius="full"
                    px={2}
                    py={1}
                    fontSize="xs"
                  >
                    {"Live"}
                  </Badge>
                </HStack>
                <Text fontSize="sm" fontWeight="light" color="white">
                  {reward.description}
                </Text>
                <HStack spacing={2} mt={1}>
                  <Text fontSize="xs" color="whiteAlpha.600">
                    Rewards:
                  </Text>
                  <HStack spacing={1}>
                      <Text fontSize="xs" color="whiteAlpha.600">
                        {reward.symbol}
                      </Text>
                      <Image
                          key={1}
                          src={reward.image}
                          alt={reward.symbol}
                          boxSize="16px"
                          borderRadius="full"
                        />
                    </HStack>
                </HStack>
              </VStack>
            </Flex>
            ))}
          </Box>
        </VStack>
      </VStack>
    );
};